import React from 'react'
import { Global, css } from '@emotion/react'
import { COLORS_V3, ColorV3Names, getV3ColorCssVariable } from '../../../design-system/colors_v3'

export const GlobalStyles = () => (
  <Global
    styles={css`
      :root {
        ${Object.entries(COLORS_V3).map(([type, colors]) =>
          Object.entries(colors).map(
            ([colorName, rgba]) =>
              `${getV3ColorCssVariable(type as ColorV3Names, colorName as never)}: ${rgba}`,
          ),
        )}
      }
    `}
  />
)
